import { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from './useReducedMotion';


export function useCountUp(value: number, enabled = true, duration = 700): number {
  const reducedMotion = useReducedMotion();
  const animated = enabled && !reducedMotion;
  const [shown, setShown] = useState(value);
  const current = useRef(value);

  useEffect(() => {
    const from = current.current;
    if (!animated || from === value) {
      current.current = value;
      setShown(value);
      return;
    }
    const startedAt = performance.now();
    let frame = requestAnimationFrame(function step(now) {
      const progress = Math.min(1, (now - startedAt) / duration);
      const next = Math.round(from + (value - from) * (1 - (1 - progress) ** 3));
      current.current = next;
      setShown(next);
      if (progress < 1) frame = requestAnimationFrame(step);
    });
    return () => cancelAnimationFrame(frame);
  }, [value, animated, duration]);

  return animated ? shown : value;
}
